import { render, staticRenderFns } from "./TeamLink.vue?vue&type=template&id=18950312&"
import script from "./TeamLink.vue?vue&type=script&lang=js&"
export * from "./TeamLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports